'use client';

import { createContext, useContext } from 'react';

export const GenericActionContext = /*#__PURE__*/ createContext<{
  API: {
    KONTENT?: any;
    CONTENTFUL?: any;
  }; // kontent api
  VIDEO_API: {
    ENDEAVOR?: any;
    ENDEAVOR_CONFIG?: any;
  };
}>({
  API: {
    KONTENT: null,
    CONTENTFUL: null,
  },
  VIDEO_API: {
    ENDEAVOR: null,
    ENDEAVOR_CONFIG: null,
  },
});

export const useGenericActionContext = () => {
  const context = useContext(GenericActionContext);
  if (!context) {
    throw new Error('useGenericActionContext must be used within an GenericActionContext Provider');
  }
  return context;
};
